import { graphql } from "gql";

const INTERNAL_ADMIN_EDIT_USER_ATTRIBUTE_MUTATION = graphql(`
  mutation InternalAdminEditUserAttribute(
    $organizationId: ID!
    $id: ID!
    $input: AdminEditUserAttributeInput!
  ) {
    internalAdminEditUserAttribute(
      organizationId: $organizationId
      id: $id
      input: $input
    ) {
      ...InternalAdminUserAttribute
    }
  }
`);

export default INTERNAL_ADMIN_EDIT_USER_ATTRIBUTE_MUTATION;
